import React, { useMemo } from 'react';
import { Row, Col } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import MetaTable from '@dex/bubl-dash/src/lib/components/MetaTable/MetaTable';
import ActivityPanel from '@dex/bubl-dash/src/lib/components/SinglePanels/ActivityPanel';
import { Space } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Seperator from '@dex/bubl-dash/src/lib/components/Seperator/Seperator';

const FeedbackSingleView: React.FC<any> = (props: any) => {

    const { data } = props;

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <Col
                className={'main'}
            >

                <Panel
                    heading={"Feedback Details"}
                >

                    <MetaTable
                        data={data}
                        columnA={[
                            {
                                label: 'ID',
                                key: 'id',
                            }
                        ]}
                        columnB={[
                            {
                                label: 'User',
                                key: 'user',
                                format: "ModelLink"
                            }
                        ]}
                        columnC={[
                            {
                                label: "Created",
                                key: "created",
                                format: "OnAndBy"
                            }
                        ]}
                    />

                    <Space height={8} />

                    {data.list &&

                        <>
                            <Seperator
                                heading={"Questions and Answers"}
                                top={"auto"}
                                bottom={"auto"}
                            />

                            <MetaTable
                                data={data.list}
                                columnA={[
                                    {
                                        label: "Question",
                                        key: "label"
                                    }
                                ]}
                                columnB={[
                                    {
                                        label: "Answer",
                                        key: "value"
                                    }
                                ]}
                            />
                        </>

                    }

                </Panel>

            </Col>

            <Col className={'side'}>

                <ActivityPanel parent={data} />

            </Col>

        </Row>

    ), [data]);

}

export default FeedbackSingleView;
